<template>
  <div
    v-if="user"
    class="flex flex-col m-0 sm:m-0 md:m-0 lg:mx-2 xl:mx-2 lg:mt-2 xl:mt-2 bg-gray-100 p-3"
  >
    <div>
      <p class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase">
        Profiel
      </p>
    </div>

    <div
      class="my-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 grid-flow-row gap-4"
    >
      <MainPropertiesCard :user="user" />
      <PasswordResetCard />
      <APITokenCard v-if="hasPermission('access api')" />
      <div class="lg:hidden xl:hidden">
        <button
          class="bg-mi-blue-500 text-center rounded-lg text-white w-full my-4 p-2"
          @click="signout()"
        >
          Uitloggen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MainPropertiesCard from "./MainPropertiesCard";
import PasswordResetCard from "./PasswordResetCard";
import APITokenCard from "./APItokenCard.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: { MainPropertiesCard, PasswordResetCard, APITokenCard },
  data() {
    return {
      //   user: this.$store.getters.current_user,
    };
  },
  computed: mapState({
    user: function() {
      return this.$store.getters.current_user;
    }
  }),
  methods: {
    signout: function() {
      this.logout();
      this.$router.push({ name: "Login" });
    },
    ...mapActions(["logout"])
  }
};
</script>

<style></style>
